function FieldLabel({ children }) {
    return <label className="flex w-full sm:text-[16px] sm:leading-[24px] text-[14px] leading-[17.5px] font-700 mb-4">
        {children}
    </label>
}

export default FieldLabel;